import $ from 'jquery';

// Class 
class QuoteSlider{
    constructor($block){
        this.$block = $block;
        this.$sliderContainer = this.$block.find('.quote-slider__content');

        this.bind();
    }

    bind(){
        this.makeSlides(this.$sliderContainer);
    }

    makeSlides(container) {
        container.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: true,
            mobileFirst: true
        });
    }
}

$( function(){
    // Maybe iterate over each of these to support multiple on a page. 
    new QuoteSlider($(".quote-slider"));
} );